export const FETCH_DESTINATIONS = 'FETCH_DESTINATIONS';
export const FETCH_ADMIN_DESTINATIONS = 'FETCH_ADMIN_DESTINATIONS';
export const SET_DESTINATIONS = 'SET_DESTINATIONS';
export const SET_START_LOCATION = 'SET_START_LOCATION';
export const SET_DEFAULT_DESTINATION = 'SET_DEFAULT_DESTINATION';
export const ADD_LOCATION = 'ADD_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const ADD_LOCATION_TO_LIST = 'ADD_LOCATION_TO_LIST';
export const REMOVE_LOCATION_FROM_LIST = 'REMOVE_LOCATION_FROM_LIST';
